import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import styles from './styles'

const useStyles = makeStyles(styles)

const ItemSummary = ({ title, value, icon }) => {
  const classes = useStyles()

  return (
    <Box
      p={2}
      textAlign="center"
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      flexDirection="column"
    >
      <div className={classes.infoIcon}>{icon}</div>
      <Typography className={classes.title} variant="overline">
        {title}
      </Typography>
      <Typography variant="h3">{value}</Typography>
    </Box>
  )
}

export default ItemSummary
